'use client';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Heading } from '@/components/ui/shared/heading';
import { MaterialIcon } from '@/components/ui/shared/materialIcon';
import { Pencil } from 'lucide-react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

export default function LoginCredentials() {
  const history = useHistory();
  return (
    <Card>
      <CardHeader className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex flex-col gap-y-2">
          <Heading variant={'userAccountTitle'}>Prisijungimo duomenys</Heading>
        </div>
        <Button
          type="submit"
          variant={'light'}
          onClick={() => history.push('/userAccount/personal-info/change-password')}
        >
          <MaterialIcon icon={'edit'} size={16} />
          Keisti slaptažodį
        </Button>
      </CardHeader>
    </Card>
  );
}
